<template>
  <Modal v-model="modalValue" :title="isEdit ? `编辑个人证书` : '新增个人证书'" width="700" @on-cancel="modalCancel">
    <Row class="modal-content">
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <div class="tag-title">基础信息</div>
          <FormItem label="状态" prop="status">
            <RadioGroup v-model="form.status">
              <Radio label="1">有效</Radio>
              <Radio label="0">无效</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="证书类型" prop="certificates_id">
            <Select
              v-model="form.certificates_id"
              filterable
              @on-change="certificatesChange"
              placeholder="请选择证书类型"
            >
              <Option v-for="(item, index) in certs" :value="item.id" :label="item.title" :key="index"></Option>
            </Select>
          </FormItem>
          <FormItem label="免冠照" prop="licence_photo">
            <upload-file-one
              @on-change="licencePhotoChange"
              :path="form.licence_photo"
              :url="form.licence_photo_url"
            ></upload-file-one>
          </FormItem>
          <FormItem label="姓名" prop="name">
            <Input v-model="form.name" placeholder="请输入姓名"></Input>
          </FormItem>
          <FormItem label="性别" prop="gender">
            <RadioGroup v-model="form.gender">
              <Radio label="1">男</Radio>
              <Radio label="2">女</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="证件号" prop="id_card">
            <Input v-model="form.id_card" placeholder="请输入证件号"></Input>
          </FormItem>
          <FormItem label="证书专业" prop="specialty">
            <Input v-model="form.specialty" placeholder="请输入证书专业"></Input>
          </FormItem>
          <FormItem label="证书编号" prop="certificate_no">
            <Input v-model="form.certificate_no" placeholder="请输入证书编号"></Input>
          </FormItem>
          <FormItem label="证书等级" prop="level">
            <Input v-model="form.level" placeholder="请输入证书等级"></Input>
          </FormItem>
          <FormItem label="证书发放日期" prop="date_of_issue">
            <Date-picker
              type="month"
              style="width: 100%"
              v-model="form.date_of_issue"
              placeholder="选择证书发放日期"
            ></Date-picker>
          </FormItem>
          <template v-if="form.certificates_fields.length > 0">
            <div class="tag-title">其他信息</div>
            <FormItem
              v-for="(item, index) in form.certificates_fields"
              :label="item.title"
              :key="index"
              class="ivu-form-item-required"
            >
              <Input v-model="item.value" :placeholder="`请输入${item.title}`"></Input>
            </FormItem>
          </template>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button type="primary" :loading="btnLoading" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import _ from 'lodash'
  import uploadFileOne from '@/components/upload-custom/upload-file-one.vue'
  import { getLoaclMonth } from '@/libs/util'
  import * as apiCertificates from '@/api/certificates'
  export default {
    name: 'add-license',
    components: {
      uploadFileOne,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        default: '',
      },
      // 证书列表
      certs: {
        type: [Array],
        default: () => {
          return []
        },
      },
    },
    data() {
      return {
        btnLoading: false,
        form: {
          certificates_id: '', // 证书id
          name: '', // 姓名
          gender: '1', // 性别
          id_card: '', // 证件号
          certificate_no: '', // 证书编号
          specialty: '', // 专业
          level: '', // 等级
          status: '1', // 状态
          date_of_issue: '', // 证书发放日期
          licence_photo: '', // 免冠照
          licence_photo_url: '',
          certificates_fields: [], // 其他字段
        },
        rules: {
          certificates_id: [{ required: true, message: '证书不能为空', trigger: 'change' }],
          name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
          gender: [{ required: true, message: '性别不能为空', trigger: 'change' }],
          id_card: [{ required: true, message: '证件号不能为空', trigger: 'blur' }],
          certificate_no: [{ required: true, message: '证书编号不能为空', trigger: 'blur' }],
          specialty: [{ required: true, message: '专业不能为空', trigger: 'blur' }],
          level: [{ required: true, message: '等级不能为空', trigger: 'blur' }],
          status: [{ required: true, message: '状态不能为空', trigger: 'change' }],
          licence_photo: [{ required: true, message: '免冠照不能为空', trigger: 'change' }],
          date_of_issue: [{ required: true, type:'date', message: '证书发放日期不能为空', trigger: 'change' }],
        },
      }
    },
    methods: {
      // 获取详情
      getDetail() {
        apiCertificates.apiCertificatesUsersDetail(this.id).then(res => {
          const { data } = res
          this.form.name = data.name
          this.form.certificates_id = data.certificates_id + ''
          this.form.gender = data.gender + ''
          this.form.id_card = data.id_card
          this.form.certificate_no = data.certificate_no
          this.form.specialty = data.specialty
          this.form.level = data.level
          this.form.status = data.status + ''
          this.form.licence_photo = data.licence_photo
          this.form.licence_photo_url = data.licence_photo_url
          this.form.certificates_fields = data.certificates_fields
          this.form.date_of_issue = data.date_of_issue
        })
      },
      // 图片上传成功
      licencePhotoChange(e) {
        this.form.licence_photo = e.path
        this.form.licence_photo_url = e.url
      },
      // 证书类型切换,获取对应证书的fields
      certificatesChange(id) {
        let obj = this.certs.find(item => item.id == id)
        if (obj) {
          this.form.certificates_fields = obj.fields.map(item => {
            return {
              ...item,
              value: '',
            }
          })
        }
      },
      // 提交
      modalConfirm() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            let opt = _.cloneDeep(this.form)
            opt.date_of_issue = getLoaclMonth(opt.date_of_issue)
            for (let i = 0; i < opt.certificates_fields.length; i++) {
              let item = opt.certificates_fields[i]
              if (item.value == '') {
                return this.$Modal.error({
                  title: '提示',
                  content: `${item.title}不能为空`,
                })
              }
            }
            opt.certificates_fields = opt.certificates_fields.map(item => {
              return {
                id: item.id,
                value: item.value,
              }
            })
            if(opt.certificates_fields.length < 1) delete opt.certificates_fields
            this.btnLoading = true
            if (this.isEdit) {
              apiCertificates.apiCertificatesUsersEdit(this.id, { ...opt }).then(res => {
                this.$Message.success('编辑证书成功')
                this.$emit('on-success')
                this.modalCancel()
              }).finally(() => this.btnLoading = false)
            } else {
              apiCertificates.apiCertificatesUsersAdd(opt).then(res => {
                this.$Message.success('新增证书成功')
                this.$emit('on-success')
                this.modalCancel()
              }).finally(() => this.btnLoading = false)
            }
          }
        })
      },
      modalCancel() {
        this.$refs['addForm'].resetFields()
        this.form.certificates_fields = []
        this.form.licence_photo_url = ''
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    watch: {
      value(val) {
        if (val && this.isEdit) {
          this.getDetail()
        }
      },
    },
  }
</script>
<style lang="less">
  .modal-content {
    height:500px;
    overflow-y: auto;
  }
</style>

